import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { UnauthLayoutComponent } from './unauth-layout/unauth-layout.component';
import { RouterModule } from '@angular/router';

import { ReactiveFormsModule } from '@angular/forms';
import { PasswordResetSentComponent } from './password-reset-sent/password-reset-sent.component';
import { MfaComponent } from './mfa/mfa.component';
import { SessionTimeoutDialogComponent } from './session-timeout-dialog/session-timeout-dialog.component';

import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from "../shared/shared.module";



@NgModule({
  declarations: [
    UnauthLayoutComponent,
    LoginComponent,
    PasswordRecoveryComponent,
    ForgotPasswordComponent,
    PasswordResetSentComponent,
    MfaComponent,
    SessionTimeoutDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatDialogModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule { }
